<template>
  <div class="contract-page">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <span class="nav-back" @click="$router.back()">
        <i class="el-icon-arrow-left"></i>
      </span>
      <span class="nav-title">在线合同</span>
    </div>

    <!-- 内容区 -->
    <div class="content">
      <div class="contract-list">
        <div
          v-for="item in contractList"
          :key="item.id"
          class="contract-item"
          @click="viewContract(item)"
        >
          <div class="contract-icon">
            <i class="el-icon-document"></i>
          </div>
          <div class="contract-info">
            <p class="contract-title">{{ item.title }}</p>
            <p class="contract-desc">{{ item.desc }}</p>
          </div>
          <i class="el-icon-arrow-right contract-arrow"></i>
        </div>
      </div>
    </div>

    <!-- 合同详情弹窗 -->
    <div v-if="showDetail" class="detail-mask" @click="showDetail = false">
      <div class="detail-modal" @click.stop>
        <div class="detail-header">
          <span class="detail-title">{{ currentContract.title }}</span>
          <span class="detail-close" @click="showDetail = false">
            <i class="el-icon-close"></i>
          </span>
        </div>
        <div class="detail-body">
          <div class="contract-content" v-html="currentContract.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnlineContract',
  data() {
    return {
      showDetail: false,
      currentContract: {},
      contractList: [
        {
          id: 1,
          title: '代驾服务协议',
          desc: '代驾服务相关条款说明',
          content: `<h3 style="font-size: 16px; color: #333; margin-bottom: 12px; font-weight: 600;">代驾服务协议</h3>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">一、服务内容</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px; text-indent: 2em;">甲方（委托方）委托乙方（代驾方）提供车辆代驾服务，乙方按照约定将车辆安全送达指定地点。</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">二、双方权利与义务</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px; text-indent: 2em;">1. 甲方应保证车辆手续齐全、车况良好，并如实告知车辆状况。</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px; text-indent: 2em;">2. 乙方应具备合法驾驶资格，安全文明驾驶，按照约定路线行驶。</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">三、费用说明</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px; text-indent: 2em;">代驾费用根据距离、车型等因素计算，具体以订单显示为准。</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">四、其他约定</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; text-indent: 2em;">本协议未尽事宜，双方协商解决。如有争议，可向平台客服投诉。</p>`
        },
        {
          id: 2,
          title: '车辆运输服务合同',
          desc: '板车托运相关条款说明',
          content: `<h3 style="font-size: 16px; color: #333; margin-bottom: 12px; font-weight: 600;">车辆运输服务合同</h3>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">一、服务内容</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px; text-indent: 2em;">甲方委托乙方提供车辆运输（板车托运）服务，乙方负责将车辆从始发地安全运输至目的地。</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">二、运输费用</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px; text-indent: 2em;">运输费用根据车辆型号、运输距离等因素确定，具体以订单约定为准。</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">三、保险责任</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px; text-indent: 2em;">运输过程中因乙方原因造成车辆损坏的，乙方按照保险约定承担相应赔偿责任。</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">四、交付与验收</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; text-indent: 2em;">车辆到达目的地后，甲方（或收车人）应及时验收并确认签收。</p>`
        },
        {
          id: 3,
          title: '用户服务协议',
          desc: '平台用户服务条款',
          content: `<h3 style="font-size: 16px; color: #333; margin-bottom: 12px; font-weight: 600;">用户服务协议</h3>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">一、服务说明</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px; text-indent: 2em;">优行运车平台为用户提供二手车代驾、板车托运等信息服务，连接供需双方。</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">二、用户注册</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px; text-indent: 2em;">用户应提供真实、准确的个人信息，因信息不实造成的损失由用户自行承担。</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px;">三、隐私保护</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 10px; text-indent: 2em;">平台严格保护用户隐私，未经用户同意，不向第三方泄露个人信息。</p>
<p style="font-size: 14px; color: #666; line-height: 1.8; text-indent: 2em;">如有疑问，请联系客服：400-7656899</p>`
        }
      ]
    }
  },
  methods: {
    viewContract(item) {
      this.currentContract = item
      this.showDetail = true
    }
  }
}
</script>

<style scoped>
.contract-page {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  background: #fff;
  position: relative;
  flex-shrink: 0;
  border-bottom: 1px solid #eee;
}

.nav-back {
  position: absolute;
  left: 12px;
  font-size: 22px;
  color: #333;
  cursor: pointer;
  padding: 4px;
}

.nav-title {
  font-size: 17px;
  font-weight: 600;
  color: #333;
}

/* 内容区 */
.content {
  flex: 1;
  padding: 12px;
}

.contract-list {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}

.contract-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
}

.contract-item:last-child {
  border-bottom: none;
}

.contract-item:active {
  background: #f9f9f9;
}

.contract-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #e8f4ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.contract-icon i {
  font-size: 22px;
  color: #4a90e2;
}

.contract-info {
  flex: 1;
  min-width: 0;
}

.contract-title {
  font-size: 15px;
  color: #333;
  font-weight: 500;
  margin-bottom: 4px;
}

.contract-desc {
  font-size: 13px;
  color: #999;
}

.contract-arrow {
  font-size: 16px;
  color: #ccc;
  margin-left: 8px;
  flex-shrink: 0;
}

/* 详情弹窗 */
.detail-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.detail-modal {
  width: 85%;
  max-width: 400px;
  max-height: 80vh;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: detail-in 0.25s ease;
}

@keyframes detail-in {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.detail-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.detail-close {
  font-size: 18px;
  color: #999;
  cursor: pointer;
  padding: 4px;
}

.detail-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}

.contract-content {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}
</style>
